import { render, staticRenderFns } from "./QockpitDocs.vue?vue&type=template&id=0d421fc0&"
import script from "./QockpitDocs.vue?vue&type=script&lang=js&"
export * from "./QockpitDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports